export default __webpack_public_path__ + "static/media/spin-bg-21.9f132d5b.png";